import { SUPPORTED_LANGUAGE } from '@store';

export namespace FlutterHeatingSystemsHelper {
  export enum RouteNames {
    Systems = 'systems', // Registered Devices
    UnregisteredSerials = 'unregistered-serials', // Unregistered devices
    WarrantyCodes = 'warranty-codes', // Warranty codes
  }

  export interface HeatingSystemsAccess {
    registeredInstallations: boolean;
    unregisteredSerials: boolean;
    warrantyCodes: boolean;
    serviceOrders: boolean;
    serviceRequests: boolean;
    commissioningInvoice: boolean;
    warrantyClaims: boolean;
    sparePartOrders: boolean;
  }

  export interface IframeSettings extends HeatingSystemsAccess {
    countryCode: string;
    language: SUPPORTED_LANGUAGE;
    targetRedirection: string;
    customerId: string; // from endopint /me company.id
  }
}
